import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { App } from "@/App";
import { initTheme } from "@/store/theme";
import "./index.css";

// Apply persisted theme immediately — before first paint — to prevent flash
initTheme();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (failureCount, error: unknown) => {
        // Don't retry auth errors
        if (typeof error === "object" && error !== null && "error" in error) {
          const { error: code, status } = error as { error: string; status?: number };
          if (code === "AUTHENTICATION_ERROR" || code === "AUTHORIZATION_ERROR") return false;
          // Retrying a missing record, or a rate limit before it resets, only makes things worse
          if (status === 404 || status === 429) return false;
        }
        return failureCount < 2;
      },
      staleTime: 30_000,
      refetchOnWindowFocus: false,
    },
  },
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
);
